import { ReactComponent as Icon } from "../files/edit-icon.svg";

import ISVGIconProps from "../ISVGIconProps";

const EditIcon = ({ fill, style }: ISVGIconProps) => {
    return <Icon style={style} fill={fill} />;
};

export default EditIcon;
